import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useHistory } from 'react-router-dom';
import { convertMoney } from '../../../../utils/utils';
import dayjs from 'dayjs';
import { Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import { authAtom } from '../../../../actions';
import { hasPermission } from '../../../../utils/utils';

const WalletItem = ({ wallet, onDelete }) => {
  const authUser = useAtomValue(authAtom)

  return (
    <TableRow sx={{ cursor: 'pointer' }}>
      <TableCell sx={{ fontSize: 11, fontWeight: '600' }}>{`#${wallet.transaction_id}`}</TableCell>
      <TableCell sx={{ fontSize: 11 }}>
        <span style={{ color: wallet.transaction_type === 1 ? 'green' : 'red' }}>
          {`${wallet.transaction_type === 1 ? '+' : '-'}${convertMoney(wallet.amount, true)}`}
        </span>
      </TableCell>
      <TableCell sx={{ fontSize: 11 }}>{dayjs(wallet.date).format('HH:mm DD/MM/YYYY')}</TableCell>
      <TableCell sx={{ fontSize: 11 }}>{wallet.note}</TableCell>
      <TableCell sx={{ fontSize: 11 }}>
        {
          hasPermission(authUser, ['delete_wallet_transaction']) &&
          <Button onClick={onDelete} variant='outlined' color='error'>Xóa</Button>
        }
      </TableCell>
    </TableRow>
  );
};

export default WalletItem;
